import React from 'react';
import PropTypes from 'prop-types';

import { getTimeAndDateOrASAP } from 'bento-ordering/base/utils/getTime';

import SecondaryCta from 'bento-ordering/base/components/SecondaryCta';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const FulfillmentTime = ({
  requestedFulfillmentIsAsap,
  fulfillmentDate,
  fulfillmentTime,
  currentPrepTime,
  changePickupTime,
  restaurantName,
  desktopFullWidth,
  dataTestId
}) => {
  const getLocationTime = () => {
    return getTimeAndDateOrASAP(
      requestedFulfillmentIsAsap,
      currentPrepTime,
      fulfillmentDate,
      fulfillmentTime
    );
  };

  const theme = useTheme();
  const isMediumAndUp = useMediaQuery(theme.breakpoints.up('md'));
  // on desktop (medium up), full width pertains to alignment (full width `true` is like "text align: center", where as full widht `false` is "text align: left"), and is configurable. on mobile, it is never full width
  const isFullWidth = isMediumAndUp ? desktopFullWidth : false;
  return (
    <SecondaryCta
      fullWidth={isFullWidth}
      type="button"
      label={`${restaurantName} ${getLocationTime()}`}
      handleClick={changePickupTime}
      dataTestId={dataTestId}
    />
  );
};

FulfillmentTime.propTypes = {
  changePickupTime: PropTypes.func,
  requestedFulfillmentIsAsap: PropTypes.bool,
  fulfillmentDate: PropTypes.string,
  fulfillmentTime: PropTypes.string,
  currentPrepTime: PropTypes.number,
  restaurantName: PropTypes.string,
  desktopFullWidth: PropTypes.bool,
  dataTestId: PropTypes.string
};

export default FulfillmentTime;
